module.exports = __webpack_public_path__ + "img/frame (98).68815c6b.jpg";